import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ImgSah } from '../../../components/ImgSah'
import LoadingContainer from '../../../components/LoadingContainer'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { appApi } from '../../../services/appApi'
import { LimparCPF } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'
import { CardPesquisa } from './components/CardPesquisa'
import { FormularioCpf } from './components/FormularioCpf'
import { iConvitePesquisa } from './interfaces'
import { Container, HeaderContainer } from './styles'
const LogoAmbiental = 'https://sigah.blob.core.windows.net/assets/front/LogoAmbiental.png'

const Titulo = 'Avaliação de desempenho 2026'
const TextoAbertura = 'Este é o canal para você responder as avaliações que estão sob sua responsabilidade. Informe seu CPF para ver o que está disponível para você.'
const ChaveSessao = 'ambiental:cpf'

export const ResponderAmbiental: React.FC = () => {
  const [Cpf, setCpf] = useState('')
  const [Erro, setErro] = useState('')
  const [IsLoading, setIsLoading] = useState(false)
  const [Convites, setConvites] = useState<iConvitePesquisa[] | null>(null)

  function PostAcesso(cpf: string): void {
    setIsLoading(true)
    setErro('')
    appApi.post('api/PesquisasExternas/VerificarConvites', { cpf: LimparCPF(cpf) })
      .then(res => {
        const data: iConvitePesquisa[] = res.data ?? []
        setConvites(data)
        sessionStorage.setItem(ChaveSessao, LimparCPF(cpf))
      })
      .catch(err => {
        sessionStorage.removeItem(ChaveSessao)
        // A api responde 400/404 com a mensagem em texto puro no corpo
        const mensagem = err?.response?.data
        setErro(typeof mensagem === 'string' && mensagem.length > 0 && mensagem.length < 200
          ? mensagem
          : 'Não encontramos pesquisas para esse CPF. Confira o número digitado.')
      })
      .finally(() => setIsLoading(false))
  }

  function Sair(): void {
    sessionStorage.removeItem(ChaveSessao)
    setConvites(null)
    setCpf('')
    setErro('')
  }

  useEffect(() => {
    const cpfSessao = sessionStorage.getItem(ChaveSessao)
    if (cpfSessao) {
      PostAcesso(cpfSessao)
    }
  }, [])

  return (
    <Body>
      <WhiteContainer padding='0'>
        <HeaderContainer>
          <h1>{Titulo}</h1>
          <img alt='Ambiental' src={LogoAmbiental} />
        </HeaderContainer>
        <Box bg='var(--DegradeAzul)' className={'gradient-blue'} h={'3px'} w={'full'}></Box>

        <Container>
          {!Convites && (
            <Flex flexDir={'column'} alignItems={'center'} gap={'2rem'}>
              <Text
                maxW={'38rem'}
                textAlign={'center'}
                fontSize={'.9375rem'}
                lineHeight={'1.5rem'}
                color={'var(--Gray2)'}
              >{TextoAbertura}</Text>

              <FormularioCpf
                cpf={Cpf}
                erro={Erro}
                isLoading={IsLoading}
                onChange={(e) => { setCpf(e); setErro('') }}
                onSubmit={() => PostAcesso(Cpf)}
              />
            </Flex>
          )}

          {Convites && (
            <Flex flexDir={'column'} gap={'1.25rem'}>
              <Flex justifyContent={'space-between'} alignItems={'flex-end'} gap={'2rem'} flexWrap={'wrap'}>
                <Flex flexDir={'column'} gap={'.25rem'}>
                  <h3>Pesquisas disponíveis para você</h3>
                  <Text fontSize={'.875rem'} color={'var(--Gray3)'}>
                    {Convites.length > 0
                      ? `Você tem ${Convites.length} ${Convites.length === 1 ? 'pesquisa' : 'pesquisas'} para responder até a data de encerramento.`
                      : 'Nenhuma pesquisa aguardando sua resposta.'}
                  </Text>
                </Flex>

                <ButtonCmp
                  OutlineColor='c7'
                  h={['2.25rem', '1.75rem']}
                  px={'1rem'}
                  fontSize={['.875rem', '.75rem']}
                  onClick={Sair}
                >Sair</ButtonCmp>
              </Flex>

              <LoadingContainer linhas={8} loading={IsLoading}>
                {Convites.length > 0 && (
                  <Grid templateColumns={'repeat(auto-fill, minmax(min(19rem, 100%), 1fr))'} gap={'1.25rem'} alignItems={'stretch'}>
                    {Convites.map(e => (
                      <CardPesquisa key={e.tokenId} convite={e} />
                    ))}
                  </Grid>
                )}

                {Convites.length === 0 && (
                  <ImgSah center textoPersonalizado='Nenhuma pesquisa disponível para você no momento.' />
                )}
              </LoadingContainer>
            </Flex>
          )}
        </Container>
      </WhiteContainer>
    </Body>
  )
}
